export default __webpack_public_path__ + "static/media/ltr-qt-img.6ca8d059.webp";